import {Identifiable} from './identifiable';
import {ProjectReference} from './project-reference';

export interface TeamMember extends Identifiable {
    name: string;
    role: keyof typeof TeamRole;
    readonly: boolean;
}

export interface MockedTeamMember extends TeamMember {
    projectReference: ProjectReference;
}

export enum TeamRole {
    TenderManager = 'Tendermanager',
    Planner = 'Planvoorbereider',
    Developer = 'Ontwikkelaar (extern)',
    ProjectLeaderClient = 'Projectleider opdrachtgever',
    Projectleader = 'Projectleider',
    Executor = 'Uitvoerder',
    Calculator = 'Calculator',
    Purchaser = 'Inkoper',
    BuyersGuide = 'Kopersbegeleider',
    WorkPlanner = 'Werkvoorbereider'
}
